type InputData = Array<Record<string, any>>

export function jsonToCsv(items: InputData, headers: Array<string>): string {
  if (items.length === 0) {
    return ''
  }

  const headerKeys = Object.keys(items[0])

  const escapeValue = (value: any): string => {
    if (value == null) return ''
    const str = String(value)

    const shouldQuote = /[",\n\r]/.test(str)
    const escaped = str.replace(/"/g, '""')

    return shouldQuote ? `"${escaped}"` : escaped
  }

  const csvRows = [
    headers.join(','),
    ...items.map(item => {
      return headerKeys.map(key => escapeValue(item[key])).join(',')
    }),
  ]

  return csvRows.join('\n')
}
